import { DeviceInfo } from 'qunar-react-native';
const isIOS = DeviceInfo.isIOS;
export function qAccessibilityLabel(accessibilityStr) {
    if (!accessibilityStr) {
        return undefined;
    }
    let accesslabProps = {
        accessibilityLabel: undefined,
        testID: undefined
    };
    if (isIOS) {
        accesslabProps.testID = accessibilityStr;
    }
    else {
        accesslabProps.testID = undefined;
        accesslabProps.accessibilityLabel = accessibilityStr;
    }
    return accesslabProps;
}
